import { isUuid } from '@sankarah/shared-util';

/**
 * `/communities/:communityId/notices` 等からコミュニティ ID を取る。
 * **`/communities/:id/community-closed` は null**（終了案内 URL をお知らせ用 ID に使わない）。
 */
export function parseCommunityIdFromUrl(url: string): string | null {
  const path = url.split('?')[0] ?? '';
  if (/\/communities\/[^/]+\/community-closed\/?$/.test(path)) {
    return null;
  }
  const segments = path.split('/').filter(Boolean);
  if (segments[0] !== 'communities' || segments.length < 2) return null;
  const id = segments[1];
  return isUuid(id) ? id : null;
}
